// Product name shown in the UI. Internal identifiers (repo, Worker, D1, MCP ids) keep "nexus".
export const BRAND = {
  name: "AI Kit CRM",
  short: "AI Kit",
  tagline: "CRM by AI Kit",
} as const;
